import collapseTemplate from './collapse.html';

class CollapseController {
  constructor() {
    this.isCollapsed = false;
  }

  $onInit(){
    if (this.showButton === undefined) {
      this.showButton = true;
    }
  }

  toggleCollapse() {
    this.isCollapsed = !this.isCollapsed;
  }
}

export default class CollapseComponent {
  constructor() {
    this.controller = CollapseController;
    this.transclude = {
      header: 'header',
      content: '?content',
    };
    this.bindings = {
      showButton: '<?',
    };
    this.template = collapseTemplate;
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/modules/utils/collapse/collapse-component.js